import PropTypes from 'prop-types'
import React from 'react'

function ResponsiveImage (props) {
  const {
    alt,
    xsmall,
    small,
    medium,
    large,
    xlarge,
    className,
  } = props

  const src = props.src || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  return (
    <picture {...className}>
      { xlarge ? <source srcSet={xlarge} media="(min-width: 1201px)" /> : null }
      { large ? <source srcSet={large} media="(min-width: 993px)" /> : null }
      { medium ? <source srcSet={medium} media="(min-width: 768px)" /> : null }
      { small ? <source srcSet={small} media="(min-width: 481px)" /> : null }
      { xsmall ? <source srcSet={xsmall} media="(min-width: 375px)" /> : null }
      <img alt={alt} src={src} />
    </picture>
  )
}

ResponsiveImage.propTypes = {
  xsmall: PropTypes.string,
  small: PropTypes.string,
  medium: PropTypes.string,
  large: PropTypes.string,
  xlarge: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  src: PropTypes.string,
}

export default ResponsiveImage
